import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { ResponsiveImage } from "../../../../components/ResponsiveImage";
import { FlavorFinderAnswerButton } from "../Buttons/FlavorFinderButtons";
import "./FlavorFinderAnswer.scss";
export const FlavorFinderAnswer = ({ answer, isActive = false, onAnswerClick }) => {
    const { backgroundImage = "", tabletBackgroundImage = "", mobileBackgroundImage = "", title, subtitle, id = "", } = answer;
    return (_jsxs("button", { className: classNames("flavorfinder__answer-container", {
            "flavorfinder__answer-container--active": isActive,
        }), onClick: () => onAnswerClick(id), children: [_jsx(ResponsiveImage, { alt: title, largeSrc: backgroundImage, mediumSrc: tabletBackgroundImage, smallSrc: mobileBackgroundImage, className: "responsive-image__container" }), _jsx(FlavorFinderAnswerButton, { title: title, subtitle: subtitle })] }));
};
//# sourceMappingURL=FlavorFinderAnswer.js.map